import React from 'react';

// W-0489 / T13b — Painel read-only com texto da ocorrencia selecionada.
// Paridade Delphi `DBMemoTexto` (UConsultaOcoAtivo.pas:420-437) — mostra
// texto sem formulario de edicao (RN-1 tela read-only).

const styles = {
  wrap: {
    background: '#f8f9fa',
    border: '1px solid #dee2e6',
    borderRadius: 4,
    padding: 12,
    minHeight: 140,
    maxHeight: 360,
    overflowY: 'auto',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    fontFamily: 'inherit',
    fontSize: 14,
    color: '#212529',
  },
  empty: {
    color: '#6c757d',
    fontStyle: 'italic',
  },
};

const DBMemoTexto = ({ texto, placeholder = 'Selecione uma ocorrência para visualizar o texto.' }) => {
  const conteudo = texto != null && String(texto).trim() !== '' ? texto : '';
  return (
    <div
      className="mt-2"
      role="region"
      aria-label="Texto da ocorrência"
      style={styles.wrap}
    >
      {conteudo ? (
        conteudo
      ) : (
        <span style={styles.empty}>{placeholder}</span>
      )}
    </div>
  );
};

export default DBMemoTexto;
